import type { ReactNode } from 'react';

interface Props {
  title: string;
  /** Säg vem som fixar det, inte bara att det saknas. */
  body: string;
  action?: ReactNode;
}

export function EmptyState({ title, body, action }: Props) {
  return (
    <div className="empty">
      <p className="empty__title">{title}</p>
      <p className="empty__body">{body}</p>
      {action}
    </div>
  );
}
